import * as React from 'react';
import { NovaCentralizedCommandingProvider, NovaGraphQLProvider } from '@nova/react';
import { novaGraphQL } from './NovaGraphQL';
import { novaCommanding } from './NovaCommanding';

export interface NovaProviderProps {
    children: React.ReactNode;
}

export const NovaContextProvider: React.FunctionComponent<NovaProviderProps> = props => {
    const { children } = props;
    return (
        <NovaGraphQLProvider graphql={novaGraphQL}>
            <NovaCentralizedCommandingProvider commanding={novaCommanding}>
                {children}
            </NovaCentralizedCommandingProvider>
        </NovaGraphQLProvider>
    );
};

NovaContextProvider.displayName = 'NovaContextProvider';
